import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import {NotificationActionTypes, successNotify,} from '../../factory/createNotification'
import {shop_createNew_Api, shop_delete_Api, shop_update_Api} from "../../../../apis";
import {NullAsDefault} from "../../../Shared";
import {notifyOnError} from "../../factory/createErrorEvent";

const useShopActions = ({
                            notifyListeners = {
                                onRefresh: undefined,
                                onCancel: undefined
                            },
                        }) => {
    const t = useTranslate()

    const {
        onRefresh = NullAsDefault,
        onCancel = NullAsDefault
    } = notifyListeners ?? {}

    const onError = notifyOnError(t)

    const {handleAsyncAction: createNewShop} = useAsyncAction({
        apiInfo: shop_createNew_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.CREATE, t)
            onRefresh()
        },
    })

    const {handleAsyncAction: editShopInfo} = useAsyncAction({
        apiInfo: shop_update_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onCancel()
        },
    })

    const {handleAsyncAction: deleteShop} = useAsyncAction({
        apiInfo: shop_delete_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.DELETE, t)
            onRefresh()
        },
    })


    return {
        createNewShop,
        editShopInfo,
        deleteShop
    }
}

export default useShopActions
